import { useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { ChangePassword } from '../databases/auth';
import BlockContainer from '../components/BlockContainer';
import { TextForm } from '../components/FormItem';

const PageAccount = () => {

    const [pw, setPw] = useState('')
    const [con, setCon] = useState('')
    const [onLoading, setLoading] = useState(false)

    useEffect(() => {
        return () => {
            setPw('');
            setCon('');
            setLoading(false)
        }
    }, [])

    const onUpdatePassword = async () => {
        try {
            setLoading(true)
            if (pw.length < 6 || pw.length > 20) throw new Error('โปรดตั้งรหัสผ่าน 6-20 ตัวอักษร') 
            if (pw !== con) throw new Error('รหัสผ่านไม่ตรงกัน') 
            await ChangePassword(pw)
            alert('เปลี่ยนรหัสผ่านสำเร็จ')
        }
        catch(e) {
            alert(e)
        }
        finally {
            setLoading(false)
        }
        
    }

    return (
        <div>
            <div className="bold">เปลี่ยนรหัสผ่าน</div>
            <BlockContainer>
                <TextForm value={pw} onChange={e => setPw(e.target.value)} type='password' title='รหัสผ่านใหม่' />
                <TextForm value={con} onChange={e => setCon(e.target.value)} type='password' title='ยืนยันรหัสผ่านใหม่' />
                <Button disabled={onLoading} onClick={onUpdatePassword}><Spinner hidden={!onLoading} animation='border' size='sm' /> เปลี่ยนรหัสผ่าน</Button>
            </BlockContainer>
        </div>
    )
}

export default PageAccount;